import axios from 'axios';
import * as rtCore from 'vue-xcore';

export default {
  name: 'httpCancelPlugin',

  // 插件是否自动安装
  autoInstall: true,

  install (Vue, options) {
    const log = Vue.prototype.$xpc.log;

    let cancelTokenMap = new Map();
    // 请求计数器，每次记录cancelId后自动加1
    let id = 0;

    /**
     * 添加用于中止请求的token和cancel方法
     * @param {*} axiosConfig
     * @returns
     */
    function addCancelToken (axiosConfig) {
      let cancel;
      const cancelToken = new axios.CancelToken(function executor (c) {
        cancel = c;
      });

      axiosConfig.cancelToken = cancelToken;
      axiosConfig.cancelTokenId = ++id;

      cancelTokenMap.set(id, () => {
        log(`【plugins/httpCancel】 正在取消【${axiosConfig.url}】的请求`);
        cancel(`【plugins/httpCancel】 取消了【${axiosConfig.url}】的请求`);
        removeCancelToken(axiosConfig);
      });

      return cancelTokenMap.get(id);
    }

    /**
     * 根据计数器id移除对应的token和cancel方法
     * @param {*} _id
     * @param {*} needCallCancel 是否需要执行中止方法
     * @returns
     */
    function removeCancelTokenById (_id, needCallCancel = false) {
      if (!cancelTokenMap.has(_id)) return;

      if (needCallCancel) {
        /** 执行完这个 cancel 会重新调用 removeCancelToken */
        cancelTokenMap.get(_id)('abort request');
      } else {
        cancelTokenMap.delete(_id);
      }
    }

    /**
     * 移除token和cancel方法
     * @param {*} axiosConfig
     * @param {*} needCallCancel 是否需要执行中止方法
     * @returns
     */
    function removeCancelToken (axiosConfig, needCallCancel = false) {
      if ('cancelTokenId' in axiosConfig === false) return;
      removeCancelTokenById(axiosConfig.cancelTokenId, needCallCancel);
    }

    /**
     * 移除所有的token和cancel方法
     * @param {*} needCallCancel 是否需要执行中止方法
     */
    // eslint-disable-next-line
    function removeAllCancelToken (needCallCancel = false) {
      cancelTokenMap.forEach((v, _id) => {
        removeCancelTokenById(_id, needCallCancel);
      });
    }

    /**
     * 设置Axios的请求拦截器，添加针对cancelToken的拦截功能
     */
    rtCore.setRequestInterceptors(
      function (config) {
        /** 接口定义式没有设置 enableAutoCancel 则默认会被中断请求 */
        if (config.enableAutoCancel !== false) {
          // 添加 cancelToken 并保存到 config
          addCancelToken(config);
        }
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    /**
     * 设置Axios的响应拦截器，添加针对cancelToken的拦截功能
     */
    rtCore.setResponseInterceptors(
      function (response) {
        return new Promise((resolve, reject) => {
          /** 请求成功，将 cancelToken 移除 */
          removeCancelToken(response.config);

          resolve(response);
        });
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/httpCancel/index.js